import { connect } from "react-redux"

import ClusterEditItemArticles from "./ClusterEditItemArticles"
import {
    clusterArticleSearchRequest,
    clusterArticleEditSelect
} from "../../../../actions/cluster-actions"

const mapStateToProps = ({ presentation, paging, entities }, props) => {
    const otherArticlesSearchIds =
        (
            paging.moderationFeed[
                presentation.clusters.otherArticlesSearchCriteria
            ] || {}
        ).data || []
    const otherArticlesSearch = otherArticlesSearchIds.map(articleId => ({
        ...entities.knowledge[articleId],
        isAdded: presentation.clusters.workingModel.articles.some(
            ({ id }) => id === articleId
        )
    }))
    const headlineArticleSearchIds =
        (
            paging.moderationFeed[
                presentation.clusters.headlineArticleSearchCriteria
            ] || {}
        ).data || []
    const headlineArticleSearch = headlineArticleSearchIds.map(articleId => ({
        ...entities.knowledge[articleId],
        isAdded: presentation.clusters.workingModel.articles.some(
            ({ id, is_headline }) => id === articleId && is_headline
        )
    }))
    return {
        otherArticlesSearchTerm: presentation.clusters.otherArticlesSearchTerm,
        otherArticlesSearch,
        isFetchingOtherArticlesSearch:
            presentation.clusters.isFetchingOtherArticlesSearch,
        headlineArticleSearchTerm:
            presentation.clusters.headlineArticleSearchTerm,
        headlineArticleSearch,
        isFetchingHeadlineArticleSearch:
            presentation.clusters.isFetchingHeadlineArticleSearch,
        ...props
    }
}

const mapDispatchToProps = dispatch => ({
    onSearch: ({ target: { name, value } }) =>
        dispatch(clusterArticleSearchRequest(name, value)),
    onApply: name => dispatch(clusterArticleSearchRequest(name, "")),
    onArticleSelect: (name, article) =>
        dispatch(clusterArticleEditSelect(name, article))
})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ClusterEditItemArticles)
